import { render, staticRenderFns } from "./CashLending.vue?vue&type=template&id=48e05bc0&scoped=true&"
import script from "./CashLending.vue?vue&type=script&lang=js&"
export * from "./CashLending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e05bc0",
  null
  
)

export default component.exports